import React from 'react';
import { InternalError } from './InternalError';
import { NotFound } from './NotFound';

const ErrorCode = {
    NotFound: 404,
    InternalError: 500
}

export const ErrorHandler = (props) => {
    const { status } = props;

    switch (status) {
        case ErrorCode.InternalError:
            return <InternalError />
        case ErrorCode.NotFound:
        default:
            return <NotFound />
    }
}